import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isEstablishmentSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IEstablishmentSearchForm): IEstablishmentSearchPost | {} => {
  if (isEstablishmentSearchFormEmpty(data) || data == undefined) { return {} }
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllEstablishments = async ( {data} : {data: IEstablishmentSearchForm}): Promise<IGetEstablishment> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  const response =  await axiosDefaultApi.post(`api/Search/Search/Establishments?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetEstablishment;
};

type QueryFnType = typeof getAllEstablishments;

type UseGetAllEstablishmentsOptions = {
  data: IEstablishmentSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllEstablishments = ({ data, config }: UseGetAllEstablishmentsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllEstablishments'],
    queryFn: () => getAllEstablishments({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};